import React from "react";
import Typography from "@mui/material/Typography";

export default function Title(props) {
	return (
		<Typography
			variant="h5"
			component="h1"
			sx={{
				fontWeight: 700,
				color: "text.primary",
				letterSpacing: "-0.02em",
			}}
		>
			{props.children}
		</Typography>
	);
}
